import styled, {css} from "styled-components";
import {confettiCharacteristics, confettiKeyframesList, CONFETTI_SHAPE} from "./confetti-props";

export const ConfettiBox = styled.div<{
    confettiIndex: number;
    startCoordinates?: {top: number; left: number;}
}>`
    /* Position it at the center of the container if no start coordinates are given */
    position: absolute;
    top: ${({startCoordinates}) => startCoordinates ? (startCoordinates.top + "px") : "50%"};
    left: ${({startCoordinates}) => startCoordinates ? (startCoordinates.left + "px") : "50%"};
    transform: translate(-50%, -50%);
    /* Make it transparent, at the beginning of the animation it becomes visible and at the end of the animation it will be fully transparent */
    opacity: 0;

    ${props => {
        const theConfetti = confettiCharacteristics[props.confettiIndex % confettiCharacteristics.length];
        if (theConfetti.shape === CONFETTI_SHAPE.Triangle) {
            return css`
                width: 0;
                height: 0;
                border-left: ${theConfetti.shapeTriangleProps.borderLeft}px
                    solid
                    transparent;
                border-right: ${theConfetti.shapeTriangleProps.borderRight}px
                    solid
                    transparent;
                border-bottom: ${theConfetti.shapeTriangleProps.borderBottom}px
                    solid
                    ${theConfetti.color};
            `;
        } else if (theConfetti.shape === CONFETTI_SHAPE.Circle) {
            return css`
                width: ${theConfetti.size}px;
                height: ${theConfetti.size}px;
                background-color: ${theConfetti.color};
                border-radius: 50%;
            `;
        } else { // CONFETTI_SHAPE.Rectangle
            return css`
                width: ${theConfetti.size}px;
                height: ${theConfetti.size}px;
                background-color: ${theConfetti.color};
            `;
        }
    }}

    animation:
      ${props => confettiKeyframesList[props.confettiIndex % confettiKeyframesList.length].spreadAndFall} ${props => confettiCharacteristics[props.confettiIndex % confettiCharacteristics.length].animationDuration}s ease-out forwards,
      ${props => confettiKeyframesList[props.confettiIndex % confettiKeyframesList.length].changeShape} ${props => confettiCharacteristics[props.confettiIndex % confettiCharacteristics.length].animationDuration}s ease-in-out forwards;

`;